import { render, staticRenderFns } from "./modalPlanes.vue?vue&type=template&id=b1202444"
import script from "./modalPlanes.vue?vue&type=script&lang=js"
export * from "./modalPlanes.vue?vue&type=script&lang=js"
import style0 from "./modalPlanes.vue?vue&type=style&index=0&id=b1202444&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports